import { onError } from '@apollo/client/link/error';
import toast from 'react-hot-toast';
import { getRefreshToken } from 'Utils/Common';
import logger from 'Utils/logger';
import { storage, KEYS } from 'Utils/storage';

function isJSONString(str) {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
}

/**
 * Logs out the current user by calling the LOGOUT mutation,
 * clearing localStorage, and redirecting to /login.
 *
 * @param {Function} common_res - The useMutation executor for LOGOUT.
 */
export const Logout = async (common_res) => {
    const xmpp_token = storage.get(KEYS.XMPP_TOKEN_ID);
    const isTrusted = storage.get(KEYS.IS_TRUSTED);
    const remove_device = isTrusted === 'yes' ? 'no' : 'yes';
    const final_remove_device = isTrusted ? remove_device : 'no';

    const res = await common_res({
        variables: {
            input: {
                remove_device: final_remove_device,
                xmpp_token: xmpp_token,
                device_type: 'web',
                fcm_token: window.firebase_token || '',
            },
        },
    });

    if (res?.data?.logout?.status) {
        storage.clear();
        window.location.href = '/login';
    }
};

/**
 * Apollo error link — handles JWT expiry and GraphQL/network errors.
 *
 * On jwt expired / UNAUTHENTICATED: attempts token refresh → reload.
 * On other GraphQL errors: parses JSON error messages and shows a toast.
 */
export const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
    if (graphQLErrors) {
        const firstError = graphQLErrors[0];

        if (
            firstError?.message?.includes('jwt expired') ||
            firstError?.extensions?.code === 'UNAUTHENTICATED'
        ) {
            getRefreshToken()
                .then(() => window.location.reload())
                .catch((error) => {
                    logger.log(error);
                    Logout();
                });
            return;
        }

        if (isJSONString(firstError?.message)) {
            const parsed = JSON.parse(firstError.message);
            logger.error('Parsed GraphQL Error:', parsed);
            toast.error(parsed?.message || 'Something went wrong.');
        } else if (firstError?.message) {
            toast.error(firstError.message);
        }

        graphQLErrors.forEach(({ message, locations, path }) => {
            logger.error(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
            );
        });
    }

    if (networkError) {
        logger.error(`[Network error]: ${networkError}`);
        const msg =
            networkError?.message?.includes('Server response was missing')
                ? 'Server is unreachable. Please try again in a moment.'
                : networkError?.message?.includes('Failed to fetch') ||
                  networkError?.message?.includes('NetworkError')
                ? 'Network error. Please check your connection and try again.'
                : networkError?.message || 'Network error. Please try again.';
        toast.error(msg);
    }
});
